// AUTO-GENERATED by scripts/gen-naati-meta.ts — do not edit by hand.
export interface NaatiVisaMeta { slug: string; code: string; nameTh: string; nameEn: string }
export interface NaatiDocMeta { slug: string; titleTh: string; titleEn: string }
export interface NaatiProvinceMeta { slug: string; provinceTh: string; provinceEn: string }

export const NAATI_VISA_META: NaatiVisaMeta[] = [
  {
    "slug": "subclass-500",
    "code": "500",
    "nameTh": "วีซ่านักเรียน (Student visa, subclass 500)",
    "nameEn": "Student visa (subclass 500)"
  },
  {
    "slug": "subclass-600",
    "code": "600",
    "nameTh": "วีซ่าท่องเที่ยว/เยี่ยมญาติ (Visitor visa, subclass 600)",
    "nameEn": "Visitor visa (subclass 600)"
  },
  {
    "slug": "subclass-820-801",
    "code": "820/801",
    "nameTh": "วีซ่าคู่ครองยื่นในออสเตรเลีย (Partner visa, subclass 820 ชั่วคราว / 801 ถาวร)",
    "nameEn": "Onshore partner visa (subclass 820 temporary / 801 permanent)"
  },
  {
    "slug": "subclass-309-100",
    "code": "309/100",
    "nameTh": "วีซ่าคู่ครองยื่นนอกออสเตรเลีย (subclass 309 ชั่วคราว / 100 ถาวร)",
    "nameEn": "Offshore partner visa (subclass 309 temporary / 100 permanent)"
  },
  {
    "slug": "subclass-300",
    "code": "300",
    "nameTh": "วีซ่าคู่หมั้น (Prospective Marriage visa, subclass 300)",
    "nameEn": "Prospective marriage visa (subclass 300)"
  },
  {
    "slug": "subclass-482",
    "code": "482",
    "nameTh": "วีซ่าทำงานที่มีนายจ้างสนับสนุน (subclass 482)",
    "nameEn": "Employer-sponsored work visa (subclass 482)"
  },
  {
    "slug": "subclass-189-190",
    "code": "189/190",
    "nameTh": "วีซ่าทักษะอิสระ 189 และวีซ่ารัฐเสนอชื่อ 190",
    "nameEn": "Skilled Independent (189) and Skilled Nominated (190) visas"
  },
  {
    "slug": "subclass-186",
    "code": "186",
    "nameTh": "วีซ่าถาวรที่นายจ้างเสนอชื่อ (ENS, subclass 186)",
    "nameEn": "Employer Nomination Scheme permanent visa (subclass 186)"
  },
  {
    "slug": "subclass-143",
    "code": "143",
    "nameTh": "วีซ่าบิดามารดาแบบมีส่วนร่วมค่าใช้จ่าย (subclass 143)",
    "nameEn": "Contributory Parent visa (subclass 143)"
  },
  {
    "slug": "subclass-417-462",
    "code": "417/462",
    "nameTh": "วีซ่าทำงานและท่องเที่ยว (Working Holiday 417 / Work and Holiday 462)",
    "nameEn": "Working Holiday (417) and Work and Holiday (462) visas"
  },
  {
    "slug": "subclass-101-802",
    "code": "101/802",
    "nameTh": "วีซ่าบุตร (Child visa, subclass 101 นอกออสฯ / 802 ในออสฯ)",
    "nameEn": "Child visa (subclass 101 offshore / 802 onshore)"
  },
  {
    "slug": "citizenship-by-descent",
    "code": "Citizenship",
    "nameTh": "การขอสัญชาติออสเตรเลียโดยการสืบสายโลหิต (Citizenship by descent)",
    "nameEn": "Australian citizenship by descent"
  }
];

export const NAATI_DOC_META: NaatiDocMeta[] = [
  {
    "slug": "marriage-certificate",
    "titleTh": "แปลทะเบียนสมรส NAATI",
    "titleEn": "NAATI Translation of Thai Marriage Certificate"
  },
  {
    "slug": "birth-certificate",
    "titleTh": "แปลสูติบัตร NAATI",
    "titleEn": "NAATI Translation of Thai Birth Certificate"
  },
  {
    "slug": "house-registration",
    "titleTh": "แปลทะเบียนบ้าน NAATI",
    "titleEn": "NAATI Translation of Thai House Registration"
  },
  {
    "slug": "police-clearance",
    "titleTh": "แปลใบตรวจประวัติอาชญากรรม NAATI",
    "titleEn": "NAATI Translation of Thai Police Clearance Certificate"
  },
  {
    "slug": "academic-transcript",
    "titleTh": "แปลทรานสคริปต์และใบปริญญา NAATI",
    "titleEn": "NAATI Translation of Academic Transcripts and Degrees"
  },
  {
    "slug": "bank-statement",
    "titleTh": "แปล Bank Statement และเอกสารการเงิน NAATI",
    "titleEn": "NAATI Translation of Bank Statements and Financial Documents"
  },
  {
    "slug": "divorce-certificate",
    "titleTh": "แปลใบหย่า NAATI",
    "titleEn": "NAATI Translation of Thai Divorce Certificate"
  },
  {
    "slug": "single-status",
    "titleTh": "แปลหนังสือรับรองความเป็นโสด NAATI",
    "titleEn": "NAATI Translation of Thai Single Status Certificate"
  },
  {
    "slug": "id-card",
    "titleTh": "แปลบัตรประชาชนและหนังสือเดินทาง NAATI",
    "titleEn": "NAATI Translation of Thai ID Card and Passport"
  },
  {
    "slug": "company-affidavit",
    "titleTh": "แปลหนังสือรับรองบริษัท NAATI",
    "titleEn": "NAATI Translation of Thai Company Affidavit"
  },
  {
    "slug": "medical-record",
    "titleTh": "แปลใบรับรองแพทย์และเวชระเบียน NAATI",
    "titleEn": "NAATI Translation of Thai Medical Certificates and Records"
  },
  {
    "slug": "driving-licence",
    "titleTh": "แปลใบขับขี่ NAATI",
    "titleEn": "NAATI Translation of Thai Driving Licence"
  },
  {
    "slug": "military-service",
    "titleTh": "แปล ส.ด.8 / ส.ด.43 NAATI",
    "titleEn": "NAATI Translation of Thai Military Service Documents"
  },
  {
    "slug": "name-change",
    "titleTh": "แปลใบเปลี่ยนชื่อ-สกุล NAATI",
    "titleEn": "NAATI Translation of Thai Name Change Certificate"
  }
];

export const NAATI_PROVINCE_META: NaatiProvinceMeta[] = [
  {
    "slug": "bangkok",
    "provinceTh": "กรุงเทพมหานคร",
    "provinceEn": "Bangkok"
  },
  {
    "slug": "phuket",
    "provinceTh": "ภูเก็ต",
    "provinceEn": "Phuket"
  },
  {
    "slug": "chiang-mai",
    "provinceTh": "เชียงใหม่",
    "provinceEn": "Chiang Mai"
  },
  {
    "slug": "chonburi",
    "provinceTh": "ชลบุรี",
    "provinceEn": "Chonburi"
  },
  {
    "slug": "khon-kaen",
    "provinceTh": "ขอนแก่น",
    "provinceEn": "Khon Kaen"
  },
  {
    "slug": "udon-thani",
    "provinceTh": "อุดรธานี",
    "provinceEn": "Udon Thani"
  },
  {
    "slug": "nong-khai",
    "provinceTh": "หนองคาย",
    "provinceEn": "Nong Khai"
  },
  {
    "slug": "nakhon-ratchasima",
    "provinceTh": "นครราชสีมา",
    "provinceEn": "Nakhon Ratchasima"
  },
  {
    "slug": "ubon-ratchathani",
    "provinceTh": "อุบลราชธานี",
    "provinceEn": "Ubon Ratchathani"
  },
  {
    "slug": "sakon-nakhon",
    "provinceTh": "สกลนคร",
    "provinceEn": "Sakon Nakhon"
  },
  {
    "slug": "nakhon-phanom",
    "provinceTh": "นครพนม",
    "provinceEn": "Nakhon Phanom"
  },
  {
    "slug": "roi-et",
    "provinceTh": "ร้อยเอ็ด",
    "provinceEn": "Roi Et"
  },
  {
    "slug": "chiang-rai",
    "provinceTh": "เชียงราย",
    "provinceEn": "Chiang Rai"
  },
  {
    "slug": "surat-thani",
    "provinceTh": "สุราษฎร์ธานี",
    "provinceEn": "Surat Thani"
  },
  {
    "slug": "songkhla",
    "provinceTh": "สงขลา",
    "provinceEn": "Songkhla"
  }
];
